// components/HeroSection.js
import React from 'react';
import styles from './Hero.module.css';

const HeroSection = () => {
  return (
    <div className={styles.heroContainer}>
      <div className={styles.heroSlide}>
        <img src="/images/slide1.jpg" alt="Slide 1" className={styles.heroImage} />
        <img src="/images/slide2.jpg" alt="Slide 2" className={styles.heroImage} />
        <img src="/images/slide3.webp" alt="Slide 3" className={styles.heroImage} />
        <img src="/images/slide4.jpg" alt="Slide 4" className={styles.heroImage} />
      </div>
      <div className={styles.heroContent}>
        <h1 className={styles.heroTitle}>Montransfert Sàrl</h1>
        <p className={styles.heroDescription}>
          TRANSPORT & LOGISTIQUE
        </p>

       <h4 className={styles.heroTitle}>VTC, location de véhicules et groupage Suisse–Sénégal </h4>  

      </div>
    </div>
  );
};

export default HeroSection;
